import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** Space reports API. */
@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      if (!context) {
        return rxjs.of([])
      }

      return gql.queries.reportIds
        .executor(context)
        .pipe(rxjs.map(ids => ids.map(id => ents.extra.space.Report.get(id))))
    },
  )

  /** @inheritdoc */
  public get: ec.models.Api<TypeParams>['get'] = (context, id) =>
    rxjs.of(
      ents.extra.space.Report.get(
        TypeAsserter.validate(id, ents.extra.space.Report.Id.assertIsId),
      ),
    )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([ec.models.Attribute.fromKey<TypeParams>('name', { name: 'Name' })])
}
